export default "__VITE_ASSET__BZS39XOo__"